import store from "~/js/store/store";
import { gsap, Cubic } from "gsap";
export default class GlobalUsersModal {
  constructor() {
    this.contents = document.querySelector('._global_users_modal');
    if(!this.contents){
      return false;
    }
    this.container = this.contents.querySelector('._container');

    this.open = document.querySelectorAll('.f-globalUsersModalOpen');
    this.close = document.querySelectorAll('.f-globalUsersModalClose');

    this.area = this.contents.querySelector('.f-area');
    this.areaOption = this.contents.querySelectorAll('.f-area option');
    this.country = this.contents.querySelector('.f-country');
    this.arrow = this.contents.querySelector('.f-arrow');
    this.countryOption = this.contents.querySelectorAll('.f-country option');
    this.onlineStore = this.contents.querySelector('.f-onlineStore');

    this.countryData = [];
    for(var i = 0; i < this.areaOption.length; i++)
    {
      this.countryData[i] = [];
    }
    for(var i = 0; i < this.countryOption.length; i++)
    {
      this.countryData[Number(this.countryOption[i].dataset.id)].push(this.countryOption[i]);
    }

    this.isOpen = false;

    this.setup()

    if(true)
    {
      store.dispatch('setGlobalUsersModal', {
        sta: true
      });
    }

    // 言語での分岐
    this.userBrowserLang =
    (window.navigator.languages && window.navigator.languages[0]) ||
    window.navigator.language ||
    window.navigator.userLanguage ||
    window.navigator.browserLanguage;
    if (
      this.userBrowserLang == 'en' ||
      this.userBrowserLang == 'en-US' ||
      this.userBrowserLang == 'en-GB' ||
      this.userBrowserLang == 'en-CA' ||
      this.userBrowserLang == 'en-AU' ||
      this.userBrowserLang == 'zh' ||
      this.userBrowserLang == 'zh-CN' ||
      this.userBrowserLang == 'zh-TW'
    ) {

      // Cookieを登録する関数
      function setCookie(name, value, options = {}) {
        options = {
          path: '/',
          secure: true,
          'max-age': 60 * 60 * 24 * 365,
        };

        let updatedCookie =
          encodeURIComponent(name) + '=' + encodeURIComponent(value);
        for (let optionKey in options) {
          updatedCookie += '; ' + optionKey;
          let optionValue = options[optionKey];
          if (optionValue !== true) {
            updatedCookie += '=' + optionValue;
          }
        }
        document.cookie = updatedCookie;
      }

      // 初回アクセス時かどうか判定
      if (document.cookie.indexOf('_im_visited=yes') === -1) {
        this.close.forEach( element => {
          element.addEventListener('click', () => {
            // EN,ZHのユーザー 初回
            setCookie('_im_visited', 'yes');
          });
        });
      }
      else {
        // EN,ZHのユーザー 2回目以降
        store.dispatch('setGlobalUsersModal', {
          sta: false
        });
      }
      
    } else {
      // EN,ZH以外が優先設定のユーザー
      store.dispatch('setGlobalUsersModal', {
        sta: false
      });
    }



    //モーダル表示時にフォーカスをモーダル内で循環させる
    this.modalElements = this.contents.querySelectorAll("a,button,input");   //フォーカスを当てたい要素を取得
    document.addEventListener('keydown', function(event)
    {
      if(this.isOpen)
      {
        var activeEl = document.activeElement;                          //フォーカスが当たっている要素
        var firstEl = this.modalElements[0];                            //モーダル内でフォーカスを当てたい最初の要素
        var lastEl = this.modalElements[this.modalElements.length - 1]; //モーダル内でフォーカスを当てたい最後の要素
        var tabKey = (9 === event.keyCode);                             //タブキーを押されたかどうか
        var shiftKey = event.shiftKey;                                  //シフトキーが押されたかどうか
        //最後の要素でタブキーが押された場合、最初の要素にフォーカスを当てる
        if(!shiftKey && tabKey && lastEl === activeEl)
        {
          event.preventDefault();
          firstEl.focus();
        }
        //最初の要素でタブキー+シフトキーが押された場合、最後の要素にフォーカスを当てる
        if(shiftKey && tabKey && firstEl === activeEl)
        {
          event.preventDefault();
          lastEl.focus();
        }
      }
    }.bind(this));
  }

  setup () {
    store.subscribe(((mutation, state) => {

      if(store.getters['globalUsersModal']())
      {
        if(!this.isOpen)
        {
          this.isOpen = true;

          gsap.to(this.contents, {
            display: "block",
            opacity: 1,
            duration: 0.3,
            ease: Cubic.easeInOut
          });
          gsap.fromTo(
            this.container,
            {
              marginTop: 30
            },
            {
              marginTop: 0,
              duration: 0.6,
              ease: Cubic.easeOut
            }
          );
          setTimeout(function()
          {
            this.contents.focus();
          }.bind(this), 300);
        }
      }
      else
      {
        if(this.isOpen)
        {
          this.isOpen = false;

          gsap.to(this.contents, {
            display: "none",
            opacity: 0,
            duration: 0.3,
            ease: Cubic.easeInOut
          });
          gsap.fromTo(
            this.container,
            {
              marginTop: 0
            },
            {
              marginTop: 30,
              duration: 0.3,
              ease: Cubic.easeIn
            }
          );
        }
      }
    }));
    this.close.forEach((elm, index) => {
      elm.addEventListener('click', (event) => {
        store.dispatch('setGlobalUsersModal', {
          sta: false
        });
      });
    });
    this.open.forEach((elm, index) => {
      elm.addEventListener('click', (event) => {
        store.dispatch('setGlobalUsersModal', {
          sta: true
        });
      });
    });
    this.area.addEventListener('change', (event) => {
      let target = event.currentTarget;
      const _index = target.selectedIndex;
      const _value = target.options[_index].value;

      this.country.innerHTML = "";
      for(var i = 0; i < this.countryData[_index].length; i++)
      {
        this.country.appendChild(this.countryData[_index][i]);
      }
      this.countryOption[1].selected = true;

      if(target.selectedIndex==0)
      {
        this.country.disabled = true;
        this.onlineStore.disabled = true;
        this.arrow.classList.add("off");
      }
      else
      {
        this.country.disabled = false;
        this.onlineStore.disabled = false;
        this.arrow.classList.remove("off");
      }

    });
    this.onlineStore.addEventListener('click', (event) => {
      const _index = this.country.selectedIndex;
      const _value = this.country.options[_index].value;
      location.href = _value;
    });
  }

}
